import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../../layouts/sidebarProposal/SidebarProposal'
import SendBackToFix from '../../../../widgets/sendToFix/SendBackToFix'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ContentHeader from '../../../../components/ContentHeader/ContentHeader'
import { startLoading, doneLoading } from '../../../../utils/loading'
// import { getReviewFeedback } from '../../../../redux/actions/reviewerFeedback'
import ErrorWidget from '../../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'

export default function SentToFix() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const mockSchema = {
    header: 'ขั้นที่ 4 ส่งกลับเพื่อแก้ไข',
    subHeader: 'ข้อเสนอโครงการ The current project Name',
    forms: {
      revise: [
        {
          id: '1-1001',
          label: 'ข้อมูลทั่วไปของโครงการ',
          subItems: [
            {
              id: '1-1002',
              projectFeedbackId: null,
              label: 'ลักษณะ ประเภทข้อเสนอ และระยะเวลาดำเนินโครงการ',
              value: null,
              placeholder: null,
              enableInput: true,
              selected: false,
              subItems: [],
              validators: null,
            },
            // {
            //   id: '1-1003',
            //   projectFeedbackId: null,
            //   label: 'ความสอดคล้องกับทิศทางเป้าหมายยุทธศาสตร์ และวัตถุประสงค์',
            //   value: null,
            //   placeholder: null,
            //   enableInput: false,
            //   selected: false,
            //   subItems: [
            //     {
            //       id: '1-1004',
            //       projectFeedbackId: null,
            //       label: 'ความสอดคล้องกับทิศทาง เป้าหมาย และยุทธศาสตร์ระยะ 10 ปี (2555-2564)',
            //       value: null,
            //       placeholder: null,
            //       enableInput: true,
            //       selected: false,
            //       subItems: null,
            //       validators: null,
            //     },
            //     {
            //       id: '1-1005',
            //       projectFeedbackId: null,
            //       label: 'ความสอดคล้องกับวัตถุประสงค์ตาม พ.ร.บ. ของ สสส.',
            //       value: null,
            //       placeholder: null,
            //       enableInput: true,
            //       selected: false,
            //       subItems: null,
            //       validators: null,
            //     },
            //   ],
            //   validators: null,
            // },
            {
              id: '1-1006',
              projectFeedbackId: null,
              label: 'กลุ่มเป้าหมายดำเนินการ ประเด็น และพื้นที่ดำเนินการ',
              value: null,
              placeholder: null,
              enableInput: false,
              selected: false,
              subItems: [
                {
                  id: '1-1007',
                  projectFeedbackId: null,
                  label: 'กลุ่มเป้าหมายดำเนินการ',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
                {
                  id: '1-1008',
                  projectFeedbackId: null,
                  label: 'ประเด็น',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
                {
                  id: '1-1009',
                  projectFeedbackId: null,
                  label: 'พื้นที่ดำเนินการ (setting)',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
                {
                  id: '1-1010',
                  projectFeedbackId: null,
                  label: 'พื้นที่ดำเนินการ (ตามเขตการปกครอง)',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
              ],
              validators: null,
            },
          ],
        },
        {
          id: '1-1011',
          label: 'ข้อเสนอโครงการ',
          subItems: [
            {
              id: '1-1012',
              projectFeedbackId: null,
              label: 'ชื่อโครงการย่อย',
              value: null,
              placeholder: null,
              enableInput: true,
              selected: false,
              subItems: [],
              validators: null,
            },
            // {
            //   id: '1-1013',
            //   projectFeedbackId: null,
            //   label: 'ความเป็นมา หลักการและเหตุผล',
            //   value: null,
            //   placeholder: null,
            //   enableInput: true,
            //   selected: false,
            //   subItems: [],
            //   validators: null,
            // },
            {
              id: '1-1014',
              projectFeedbackId: null,
              label: 'วัตถุประสงค์',
              value: null,
              placeholder: null,
              enableInput: false,
              selected: false,
              subItems: [
                // {
                //   id: '1-1015',
                //   projectFeedbackId: null,
                //   label: 'เป้าประสงค์',
                //   value: null,
                //   placeholder: null,
                //   enableInput: true,
                //   selected: false,
                //   subItems: null,
                //   validators: null,
                // },
                {
                  id: '1-1016',
                  projectFeedbackId: null,
                  label: 'วัตถุประสงค์',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
                {
                  id: '1-1017',
                  projectFeedbackId: null,
                  label: 'ผลลัพธ์, ตัวชี้วัด (outcome / Impact) : เชิงคุณภาพ',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
              ],
              validators: null,
            },
            {
              id: '1-1018',
              projectFeedbackId: null,
              label: 'กิจกรรม และงบประมาณ',
              value: null,
              placeholder: null,
              enableInput: false,
              selected: false,
              subItems: [
                {
                  id: '1-1019',
                  projectFeedbackId: null,
                  label: 'ค่าใช้จ่ายในการดำเนินกิจกรรม',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
                {
                  id: '1-1020',
                  projectFeedbackId: null,
                  label: 'ค่าบริหารจัดการ (ค่าธรรมเนียมสถาบัน)',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
                {
                  id: '1-1021',
                  projectFeedbackId: null,
                  label: 'ค่าบริหารจัดการ (ค่าตอบแทนผู้ร่วมโครงการ)',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
                {
                  id: '1-1022',
                  projectFeedbackId: null,
                  label: 'ค่าบริหารจัดการ (ค่าบริหารจัดการสำนักงานและอื่นๆ)',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
                {
                  id: '1-1023',
                  projectFeedbackId: null,
                  label: 'ค่าครุภัณฑ์โครงการ',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
                {
                  id: '1-1024',
                  projectFeedbackId: null,
                  label: 'งบประมาณสมทบจากแหล่งอื่น ๆ (อยู่นอกเหนืองบประมาณโครงการที่ขอรับกับ สสส)',
                  value: null,
                  placeholder: null,
                  enableInput: true,
                  selected: false,
                  subItems: null,
                  validators: null,
                },
              ],
              validators: null,
            },
            // {
            //   id: '1-1025',
            //   projectFeedbackId: null,
            //   label: 'โครงสร้างการบริหารโครงการ',
            //   value: null,
            //   placeholder: null,
            //   enableInput: true,
            //   selected: false,
            //   subItems: [],
            //   validators: null,
            // },
            // {
            //   id: '1-1026',
            //   projectFeedbackId: null,
            //   label: 'คณะทำงาน',
            //   value: null,
            //   placeholder: null,
            //   enableInput: true,
            //   selected: false,
            //   subItems: [],
            //   validators: null,
            // },
            // {
            //   id: '1-1027',
            //   projectFeedbackId: null,
            //   label: 'การกำกับติดตาม และการประเมินติดตามภายใน',
            //   value: null,
            //   placeholder: null,
            //   enableInput: true,
            //   selected: false,
            //   subItems: [],
            //   validators: null,
            // },
            // {
            //   id: '1-1028',
            //   projectFeedbackId: null,
            //   label: 'ผลที่คาดว่าจะได้รับ',
            //   value: null,
            //   placeholder: null,
            //   enableInput: true,
            //   selected: false,
            //   subItems: [],
            //   validators: null,
            // },
          ],
        },
        {
          id: '1-1029',
          label: 'ผู้รับทุน ผู้รับผิดชอบโครงการ',
          subItems: [
            {
              id: '1-1030',
              projectFeedbackId: null,
              label: 'ผู้รับทุน',
              value: null,
              placeholder: null,
              enableInput: true,
              selected: false,
              subItems: [],
              validators: null,
            },
            {
              id: '1-1031',
              projectFeedbackId: null,
              label: 'ผู้รับผิดชอบโครงการ',
              value: null,
              placeholder: null,
              enableInput: true,
              selected: false,
              subItems: [],
              validators: null,
            },
            // {
            //   id: '1-1032',
            //   projectFeedbackId: null,
            //   label: 'คุณสมบัติพื้นฐานและลักษณะต้องห้ามผู้นำเสนอโครงการ',
            //   value: null,
            //   placeholder: null,
            //   enableInput: true,
            //   selected: false,
            //   subItems: [],
            //   validators: null,
            // },
          ],
        },
      ],
    },
  }

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      // const _schema = await getReviewFeedback(proposalId)
      // console.log('call api => ', JSON.stringify(_schema))

      setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    const projectId = '9BE3B891-FD65-416B-8459-7AD624B5D3F2'
    console.log('load ProposalRevise proposal', projectId)
    projectId && handleGetSchema(projectId)
  }, [])

  if (error) {
    return (
      <SidebarProposal isSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isSubProject statusDefault={7}>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          {schema?.forms?.revise && (
            <SendBackToFix id={schema.projectReviewId} schema={schema.forms.revise} />
          )}

          <br />
        </SidebarProposal>
      )}
    </>
  )
}
